<template>
  <!-- <div > -->
  <!-- <p>{{dataPorjectPerId.length}}</p> -->
  <div v-if="dataPorjectPerId.length > 0">
    <carousel
      :items="1"
      :nav="false"
      :dots="false"
      :autoplay="true"
      :loop="true"
      :autoplayTimeout="30000"
    >
      <div class="card-primary" v-for="data in dataPorjectPerId" :key="data.id">
        <div class="row">
          <div class="col-6">
            <div class="row">
              <div class="col-12">
                <p class="text-xl text-bold text-project">{{ data.name }}</p>
              </div>
              <div class="col-12 mt-10">
                <div class="card-blue-xxs text-bold">
                  <div class="row">
                    <div class="col-6">
                      <p class="text-xl vertical-align">Total Issue</p>
                    </div>
                    <div class="col-6 text-right">
                      <p class="text-xxl vertical-align">
                        {{
                          data.status_count.Closed +
                          data.status_count.Feedback +
                          data.status_count.New +
                          data.status_count["In Progress"]
                        }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="row">
                  <div class="col-4">
                    <div class="card-red-xxs height-card text-bold">
                      <div class="row">
                        <div class="col-12 p-10">
                          <p class="text-m text-center">Open Issue</p>
                        </div>
                        <div class="col-12">
                          <p class="text-xl text-center">
                            {{
                              data.status_count.New + data.status_count.Feedback
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="card-yellow-xxs height-card text-bold">
                      <div class="row">
                        <div class="col-12 p-10">
                          <p class="text-m text-center">In Progress</p>
                        </div>
                        <div class="col-12">
                          <p class="text-xl text-center">
                            {{
                              data.status_count["In Progress"] +
                              data.status_count.Feedback
                            }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="card-green-xxs height-card text-bold">
                      <div class="row">
                        <div class="col-12 p-10">
                          <p class="text-m text-center">Closed Issue</p>
                        </div>
                        <div class="col-12">
                          <p class="text-xl text-center">
                            {{ data.status_count.Closed }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6 mt-10">
            <div class="row text-center" v-if="data.members.length <= 6">
              <div
                class="col-4"
                v-for="membersProject in data.members"
                :key="membersProject.id"
              >
                <router-link v-bind:to="'/profile/' + membersProject.user.name">
                  <img
                    class="img-round mb-20"
                    :src="
                      require(`@/assets/profile/closeup/${membersProject.user.name}-close.jpg`)
                    "
                    alt=""
                  />
                  <p class="text-s text-project">
                    {{ membersProject.user.name }}
                  </p>
                  <div
                    class="col-12 roles-5"
                    v-for="roles in membersProject.roles"
                    :key="roles.id"
                  >
                    <p class="text-s text-bold" id="text-roles-5">
                      {{ roles.name }}
                    </p>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="row text-center" v-else>
              <div
                class="col-3"
                v-for="membersProject in data.members"
                :key="membersProject.id"
              >
                <router-link v-bind:to="'/profile/' + membersProject.user.name">
                  <img
                    class="img-round mb-20"
                    :src="
                      require(`@/assets/profile/closeup/${membersProject.user.name}-close.jpg`)
                    "
                    alt=""
                  />
                  <p class="text-s text-bold">{{ membersProject.user.name }}</p>
                  <div
                    class="col-12 roles-5"
                    v-for="roles in membersProject.roles"
                    :key="roles.id"
                  >
                    <p class="text-s" id="text-roles-5">{{ roles.name }}</p>
                  </div>
                </router-link>
              </div>
            </div>
          </div>

          <div class="col-12">
            <CardOpenIssue :issue="data.issues" />
          </div>
        </div>
      </div>
    </carousel>
  </div>

  <!-- </div> -->
</template>

<script>
// import carousel from 'vue-owl-carousel'
import CardOpenIssue from "@/components/Home/CardOpenIssue.vue";
import carousel from "vue-owl-carousel";
import axios from "axios";

export default {
  name: "CarouselProject",
  components: {
    carousel,
    CardOpenIssue,
  },
  data() {
    return {
      dataPorjectPerId: [],
    };
  },
  methods: {
    setCarousel(data) {
      this.dataPorjectPerId = data;
    },
  },
  mounted() {
    var token = localStorage.token;
    document.body.classList.add("container-highlight");

    axios
      .get( "projects/details")
      .then((response) =>
        // handle success
        this.setCarousel(response.data)
      )
      .catch((error) =>
        // handle error
        console.log(error)
      );
  },
};
</script>

<style scoped>
.height-card {
  height: 100% !important;
}

.p-10 {
  padding: 0px 0px 40px 0px;
}

.owl-carousel .owl-item img {
  display: block;
  width: 70%;
  margin: auto;
}

.mb-20 {
  margin-bottom: 20px !important;
  display: block;
  /* width: 70%; */
  margin: auto;
}

a {
  color: inherit; /* blue colors for links too */
  text-decoration: inherit; /* no underline */
}

.text-project {
  font-weight: 700;
}

.card-primary {
  height: 950px;
}
</style>


// WEBPACK FOOTER //
// src/components/Home/CarouselProject.vue